import { lazy } from 'solid-js'
import { messages } from '../../pages/newsroom-page/newsroom-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/newsroom-page/newsroom-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/newsroom',
    titleMessage: messages.titleMessage,
}
